// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * Filter Panel CSS Module
 * Styles for the filter overlay and accordion components
 */
.S9dRPHMUaiVj0EOLJgIY {
  position: absolute;
  top: 56px;
  /* Below the search header */
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 10;
}
.CqSqzdS1cRY8uLp6CxVv {
  position: relative;
  max-height: 100%;
  /* Don't exceed wrapper bounds */
  display: flex;
  flex-direction: column;
  background: var(--search-background, #2f2f2f);
  box-shadow: 0px 4px 4px 0px #00000040;
  padding: 0 8px 8px;
  border-bottom-right-radius: 10px;
  border-bottom-left-radius: 10px;
  animation: fFKe1TGdsWHWFiqdlGQ6 0.35s cubic-bezier(0.34, 1.56, 0.64, 1);
}
@media (orientation: landscape) and (max-height: 410px) {
  .CqSqzdS1cRY8uLp6CxVv {
    box-shadow: none;
  }
}
/* Scrollable accordions container */
.y6QQ5XisZaP6Wnw3EdQO {
  flex: 1;
  overflow-y: auto;
  min-height: 0;
  /* Required for flex child to scroll */
  /* Custom scrollbar */
  scrollbar-width: thin;
  scrollbar-color: #555555 #48494B;
}
.y6QQ5XisZaP6Wnw3EdQO::-webkit-scrollbar {
  width: 8px;
}
.y6QQ5XisZaP6Wnw3EdQO::-webkit-scrollbar-track {
  background: #48494B;
  border-radius: 4px;
}
.y6QQ5XisZaP6Wnw3EdQO::-webkit-scrollbar-thumb {
  background: #555555;
  border-radius: 4px;
}
.y6QQ5XisZaP6Wnw3EdQO::-webkit-scrollbar-thumb:hover {
  background: #666666;
}
@keyframes fFKe1TGdsWHWFiqdlGQ6 {
  0% {
    opacity: 0;
    transform: translateY(-15px);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
}
.WY3z6f4pD5sxRC4GgPB8 {
  font-family: 'Futura PT', sans-serif;
  font-weight: 500;
  font-size: 20px;
  color: rgba(255, 255, 255, 0.7);
  line-height: 1;
  padding: 0 0 8px;
}
/* Accordion Wrapper */
.pnl8H5N5LeLploXEGSxR {
  margin-bottom: 8px;
  background: var(--filter-accordion-background, #393A3A);
  border: 1px solid #454545;
  border-radius: 10px;
  overflow: hidden;
}
.pnl8H5N5LeLploXEGSxR:last-child {
  margin-bottom: 0;
}
.GXc4KngkGE5q9CmZDSXS {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 11px 0;
  color: #FFFFFFB2;
  font-size: 18px;
  font-weight: 700;
  line-height: 20px;
  cursor: pointer;
}
.GXc4KngkGE5q9CmZDSXS:hover {
  opacity: 0.9;
}
/* Active label when filters are selected - pilotGreen from theme */
.mRNEjlcE2pcxqfHUIYY9 {
  color: var(--piliot-green, #3CFF00);
}
/* Arrow rotation */
.cwcSdxUGh_5fRdrtqQvS {
  transition: transform 0.35s cubic-bezier(0.4, 0, 0.2, 1);
}
.JX_tQfWXbIc0GxSKqoSB {
  transform: rotate(180deg);
}
/* Accordion Content */
.mWdYQf8Epzw5oZ3duJ6N {
  display: grid;
  grid-template-rows: 0fr;
  overflow: hidden;
  transition: grid-template-rows 0.3s ease-out;
}
.mWdYQf8Epzw5oZ3duJ6N > div {
  min-height: 0;
  overflow: hidden;
}
.mWdYQf8Epzw5oZ3duJ6N > div .MtvWUIpPIALMq279CduF {
  box-shadow: none;
}
.r_vAVf2tn_cxEirtppdh {
  grid-template-rows: 1fr;
}
.r_vAVf2tn_cxEirtppdh .NPZ8MlNzo6938vcDWLqg {
  padding-bottom: 11px;
}
.r_vAVf2tn_cxEirtppdh > div .MtvWUIpPIALMq279CduF {
  box-shadow: 0px 0px 4px 0px #000000CC;
}
/* Filter Chips Container */
.NPZ8MlNzo6938vcDWLqg {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  padding: 8px 11px 0;
  transition: padding-bottom 0.3s ease-out;
}
/* Filter Chip */
.EO7IZHpVtkHw9Gz5V_tp {
  height: auto;
  width: auto;
  min-width: 31px;
  min-height: unset;
  padding: 4px 9px;
  color: #CACACA;
  font-size: 18px;
  font-weight: 500;
  line-height: 1;
  text-align: center;
  background: #48494B;
  border: 1px solid transparent;
  border-radius: 38px;
  cursor: pointer;
  transition: background 0.3s ease-out, border-color 0.3s ease-out, color 0.3s ease-out;
}
.EO7IZHpVtkHw9Gz5V_tp:hover {
  background: #48494B;
}
.EO7IZHpVtkHw9Gz5V_tp:focus {
  background: #48494B;
  outline: none;
}
.EO7IZHpVtkHw9Gz5V_tp:active {
  background: #5A5B5C;
}
.MtvWUIpPIALMq279CduF {
  color: #F9F9F9;
  border-color: #A1A1A1;
  background: #767778;
  transition: box-shadow 0.3s ease-out;
}
.MtvWUIpPIALMq279CduF:hover,
.MtvWUIpPIALMq279CduF:focus,
.MtvWUIpPIALMq279CduF:active {
  background: #767778;
}
/* Inline chips shown when accordion is closed */
.Esy2qPiRFpj_fun_7aim {
  position: relative;
  display: flex;
  flex-wrap: nowrap;
  gap: 4px;
  margin-left: 12px;
  margin-right: 8px;
  flex: 1;
  overflow: hidden;
  animation: QcSiPz72RfTYupO6rqPC 0.3s ease-out;
}
@keyframes QcSiPz72RfTYupO6rqPC {
  from {
    opacity: 0;
    transform: translateX(-8px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}
.Esy2qPiRFpj_fun_7aim::after {
  content: '';
  position: absolute;
  right: 0;
  top: 0;
  bottom: 0;
  width: 24px;
  background: linear-gradient(to right, transparent, #393A3A);
  pointer-events: none;
}
.hnDnFKm4Ggw9XsafK5rl {
  background: #48494B;
  border: 1px solid transparent;
  border-radius: 14px;
  padding: 1px 6px;
  height: auto;
  width: auto;
  min-width: 24px;
  min-height: unset;
  text-align: center;
  line-height: 1;
  color: #F9F9F9;
  font-size: 16px;
  font-weight: 400;
  white-space: nowrap;
  flex-shrink: 0;
}
/* Filter Action Buttons */
.Tn3Xe3LDJKhNvwlr87lI {
  display: flex;
  gap: 8px;
  margin-top: 16px;
  justify-content: center;
}
.qzl2IlymYpxEpfjfJpXH,
.W8D1GmeKJE157CVV18wc {
  width: auto;
  height: auto;
  min-width: 180px;
  min-height: unset;
  padding: 7px 12px;
  font-size: 18px;
  line-height: 22px;
  border-radius: 8px;
  cursor: pointer;
}
.qzl2IlymYpxEpfjfJpXH {
  font-weight: 500;
  background: #313131;
  border: 1px solid #454545;
  color: #FFFFFFB2;
}
.W8D1GmeKJE157CVV18wc {
  font-weight: 600;
  background: #FFFFFF;
  border: 1px solid transparent;
  color: #1C1C1E;
}
@media (orientation: landscape) and (max-height: 430px) {
  .Tn3Xe3LDJKhNvwlr87lI {
    padding: 0 28px;
  }
  .qzl2IlymYpxEpfjfJpXH,
  .W8D1GmeKJE157CVV18wc {
    width: 100%;
  }
}
@media (max-width: 430px) {
  .qzl2IlymYpxEpfjfJpXH,
  .W8D1GmeKJE157CVV18wc {
    min-width: 160px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/features/search/components/FilterPanel/FilterPanel.module.css"],"names":[],"mappings":"AAAA;;;EAGE;AACF;EACE,kBAAkB;EAClB,SAAS;EACT,4BAA4B;EAC5B,OAAO;EACP,QAAQ;EACR,SAAS;EACT,WAAW;AACb;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gCAAgC;EAChC,aAAa;EACb,sBAAsB;EACtB,6CAA6C;EAC7C,qCAAqC;EACrC,kBAAkB;EAClB,gCAAgC;EAChC,+BAA+B;EAC/B,uEAA4D;AAC9D;AACA;EACE;IACE,gBAAgB;EAClB;AACF;AACA,oCAAoC;AACpC;EACE,OAAO;EACP,gBAAgB;EAChB,aAAa;EACb,sCAAsC;EACtC,qBAAqB;EACrB,qBAAqB;EACrB,gCAAgC;AAClC;AACA;EACE,UAAU;AACZ;AACA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,mBAAmB;AACrB;AACA;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;AACA;EACE,oCAAoC;EACpC,gBAAgB;EAChB,eAAe;EACf,+BAA+B;EAC/B,cAAc;EACd,gBAAgB;AAClB;AACA,sBAAsB;AACtB;EACE,kBAAkB;EAClB,uDAAuD;EACvD,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;AACjB;AACA;EACE,YAAY;AACd;AACA,mEAAmE;AACnE;EACE,mCAAmC;AACrC;AACA,mBAAmB;AACnB;EACE,wDAAwD;AAC1D;AACA;EACE,yBAAyB;AAC3B;AACA,sBAAsB;AACtB;EACE,aAAa;EACb,uBAAuB;EACvB,gBAAgB;EAChB,4CAA4C;AAC9C;AACA;EACE,aAAa;EACb,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,qCAAqC;AACvC;AACA,2BAA2B;AAC3B;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,mBAAmB;EACnB,wCAAwC;AAC1C;AACA,gBAAgB;AAChB;EACE,YAAY;EACZ,WAAW;EACX,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,6BAA6B;EAC7B,mBAAmB;EACnB,eAAe;EACf,qFAAqF;AACvF;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,aAAa;AACf;AACA;EACE,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,qBAAqB;EACrB,mBAAmB;EACnB,oCAAoC;AACtC;AACA;;;EAGE,mBAAmB;AACrB;AACA,gDAAgD;AAChD;EACE,kBAAkB;EAClB,aAAa;EACb,iBAAiB;EACjB,QAAQ;EACR,iBAAiB;EACjB,iBAAiB;EACjB,OAAO;EACP,gBAAgB;EAChB,6CAAoC;AACtC;AACA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,MAAM;EACN,SAAS;EACT,WAAW;EACX,2DAA2D;EAC3D,oBAAoB;AACtB;AACA;EACE,mBAAmB;EACnB,6BAA6B;EAC7B,mBAAmB;EACnB,gBAAgB;EAChB,YAAY;EACZ,WAAW;EACX,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;EACd,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;AAChB;AACA,0BAA0B;AAC1B;EACE,aAAa;EACb,QAAQ;EACR,gBAAgB;EAChB,uBAAuB;AACzB;AACA;;EAEE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,6BAA6B;EAC7B,cAAc;AAChB;AACA;EACE;IACE,eAAe;EACjB;EACA;;IAEE,WAAW;EACb;AACF;AACA;EACE;;IAEE,gBAAgB;EAClB;AACF","sourcesContent":["/**\n * Filter Panel CSS Module\n * Styles for the filter overlay and accordion components\n */\n.filterOverlayWrapper {\n  position: absolute;\n  top: 56px;\n  /* Below the search header */\n  left: 0;\n  right: 0;\n  bottom: 0;\n  z-index: 10;\n}\n.filterOverlay {\n  position: relative;\n  max-height: 100%;\n  /* Don't exceed wrapper bounds */\n  display: flex;\n  flex-direction: column;\n  background: var(--search-background, #2f2f2f);\n  box-shadow: 0px 4px 4px 0px #00000040;\n  padding: 0 8px 8px;\n  border-bottom-right-radius: 10px;\n  border-bottom-left-radius: 10px;\n  animation: slideDown 0.35s cubic-bezier(0.34, 1.56, 0.64, 1);\n}\n@media (orientation: landscape) and (max-height: 410px) {\n  .filterOverlay {\n    box-shadow: none;\n  }\n}\n/* Scrollable accordions container */\n.accordionsContainer {\n  flex: 1;\n  overflow-y: auto;\n  min-height: 0;\n  /* Required for flex child to scroll */\n  /* Custom scrollbar */\n  scrollbar-width: thin;\n  scrollbar-color: #555555 #48494B;\n}\n.accordionsContainer::-webkit-scrollbar {\n  width: 8px;\n}\n.accordionsContainer::-webkit-scrollbar-track {\n  background: #48494B;\n  border-radius: 4px;\n}\n.accordionsContainer::-webkit-scrollbar-thumb {\n  background: #555555;\n  border-radius: 4px;\n}\n.accordionsContainer::-webkit-scrollbar-thumb:hover {\n  background: #666666;\n}\n@keyframes slideDown {\n  0% {\n    opacity: 0;\n    transform: translateY(-15px);\n  }\n  100% {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n.filterHeader {\n  font-family: 'Futura PT', sans-serif;\n  font-weight: 500;\n  font-size: 20px;\n  color: rgba(255, 255, 255, 0.7);\n  line-height: 1;\n  padding: 0 0 8px;\n}\n/* Accordion Wrapper */\n.accordionWrapper {\n  margin-bottom: 8px;\n  background: var(--filter-accordion-background, #393A3A);\n  border: 1px solid #454545;\n  border-radius: 10px;\n  overflow: hidden;\n}\n.accordionWrapper:last-child {\n  margin-bottom: 0;\n}\n.accordionItem {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 8px 11px 0;\n  color: #FFFFFFB2;\n  font-size: 18px;\n  font-weight: 700;\n  line-height: 20px;\n  cursor: pointer;\n}\n.accordionItem:hover {\n  opacity: 0.9;\n}\n/* Active label when filters are selected - pilotGreen from theme */\n.accordionLabelActive {\n  color: var(--piliot-green, #3CFF00);\n}\n/* Arrow rotation */\n.accordionArrow {\n  transition: transform 0.35s cubic-bezier(0.4, 0, 0.2, 1);\n}\n.accordionArrowOpen {\n  transform: rotate(180deg);\n}\n/* Accordion Content */\n.accordionContent {\n  display: grid;\n  grid-template-rows: 0fr;\n  overflow: hidden;\n  transition: grid-template-rows 0.3s ease-out;\n}\n.accordionContent > div {\n  min-height: 0;\n  overflow: hidden;\n}\n.accordionContent > div .filterChipSelected {\n  box-shadow: none;\n}\n.accordionContentOpen {\n  grid-template-rows: 1fr;\n}\n.accordionContentOpen .filterChipsContainer {\n  padding-bottom: 11px;\n}\n.accordionContentOpen > div .filterChipSelected {\n  box-shadow: 0px 0px 4px 0px #000000CC;\n}\n/* Filter Chips Container */\n.filterChipsContainer {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 10px;\n  padding: 8px 11px 0;\n  transition: padding-bottom 0.3s ease-out;\n}\n/* Filter Chip */\n.filterChip {\n  height: auto;\n  width: auto;\n  min-width: 31px;\n  min-height: unset;\n  padding: 4px 9px;\n  color: #CACACA;\n  font-size: 18px;\n  font-weight: 500;\n  line-height: 1;\n  text-align: center;\n  background: #48494B;\n  border: 1px solid transparent;\n  border-radius: 38px;\n  cursor: pointer;\n  transition: background 0.3s ease-out, border-color 0.3s ease-out, color 0.3s ease-out;\n}\n.filterChip:hover {\n  background: #48494B;\n}\n.filterChip:focus {\n  background: #48494B;\n  outline: none;\n}\n.filterChip:active {\n  background: #5A5B5C;\n}\n.filterChipSelected {\n  color: #F9F9F9;\n  border-color: #A1A1A1;\n  background: #767778;\n  transition: box-shadow 0.3s ease-out;\n}\n.filterChipSelected:hover,\n.filterChipSelected:focus,\n.filterChipSelected:active {\n  background: #767778;\n}\n/* Inline chips shown when accordion is closed */\n.inlineChipsContainer {\n  position: relative;\n  display: flex;\n  flex-wrap: nowrap;\n  gap: 4px;\n  margin-left: 12px;\n  margin-right: 8px;\n  flex: 1;\n  overflow: hidden;\n  animation: fadeSlideIn 0.3s ease-out;\n}\n@keyframes fadeSlideIn {\n  from {\n    opacity: 0;\n    transform: translateX(-8px);\n  }\n  to {\n    opacity: 1;\n    transform: translateX(0);\n  }\n}\n.inlineChipsContainer::after {\n  content: '';\n  position: absolute;\n  right: 0;\n  top: 0;\n  bottom: 0;\n  width: 24px;\n  background: linear-gradient(to right, transparent, #393A3A);\n  pointer-events: none;\n}\n.inlineChip {\n  background: #48494B;\n  border: 1px solid transparent;\n  border-radius: 14px;\n  padding: 1px 6px;\n  height: auto;\n  width: auto;\n  min-width: 24px;\n  min-height: unset;\n  text-align: center;\n  line-height: 1;\n  color: #F9F9F9;\n  font-size: 16px;\n  font-weight: 400;\n  white-space: nowrap;\n  flex-shrink: 0;\n}\n/* Filter Action Buttons */\n.filterActions {\n  display: flex;\n  gap: 8px;\n  margin-top: 16px;\n  justify-content: center;\n}\n.clearButton,\n.showResultsButton {\n  width: auto;\n  height: auto;\n  min-width: 180px;\n  min-height: unset;\n  padding: 7px 12px;\n  font-size: 18px;\n  line-height: 22px;\n  border-radius: 8px;\n  cursor: pointer;\n}\n.clearButton {\n  font-weight: 500;\n  background: #313131;\n  border: 1px solid #454545;\n  color: #FFFFFFB2;\n}\n.showResultsButton {\n  font-weight: 600;\n  background: #FFFFFF;\n  border: 1px solid transparent;\n  color: #1C1C1E;\n}\n@media (orientation: landscape) and (max-height: 430px) {\n  .filterActions {\n    padding: 0 28px;\n  }\n  .clearButton,\n  .showResultsButton {\n    width: 100%;\n  }\n}\n@media (max-width: 430px) {\n  .clearButton,\n  .showResultsButton {\n    min-width: 160px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"filterOverlayWrapper": `S9dRPHMUaiVj0EOLJgIY`,
	"filterOverlay": `CqSqzdS1cRY8uLp6CxVv`,
	"slideDown": `fFKe1TGdsWHWFiqdlGQ6`,
	"accordionsContainer": `y6QQ5XisZaP6Wnw3EdQO`,
	"filterHeader": `WY3z6f4pD5sxRC4GgPB8`,
	"accordionWrapper": `pnl8H5N5LeLploXEGSxR`,
	"accordionItem": `GXc4KngkGE5q9CmZDSXS`,
	"accordionLabelActive": `mRNEjlcE2pcxqfHUIYY9`,
	"accordionArrow": `cwcSdxUGh_5fRdrtqQvS`,
	"accordionArrowOpen": `JX_tQfWXbIc0GxSKqoSB`,
	"accordionContent": `mWdYQf8Epzw5oZ3duJ6N`,
	"filterChipSelected": `MtvWUIpPIALMq279CduF`,
	"accordionContentOpen": `r_vAVf2tn_cxEirtppdh`,
	"filterChipsContainer": `NPZ8MlNzo6938vcDWLqg`,
	"filterChip": `EO7IZHpVtkHw9Gz5V_tp`,
	"inlineChipsContainer": `Esy2qPiRFpj_fun_7aim`,
	"fadeSlideIn": `QcSiPz72RfTYupO6rqPC`,
	"inlineChip": `hnDnFKm4Ggw9XsafK5rl`,
	"filterActions": `Tn3Xe3LDJKhNvwlr87lI`,
	"clearButton": `qzl2IlymYpxEpfjfJpXH`,
	"showResultsButton": `W8D1GmeKJE157CVV18wc`
};
export default ___CSS_LOADER_EXPORT___;
